export default "__VITE_ASSET__DPBAd5sU__"